// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"banner_wrapper__6mMVG","wrapperCard":"banner_wrapperCard__pPfvE","wrapperHorizontal":"banner_wrapperHorizontal__NG1xy","img":"banner_img__4eyE1"};